import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm',
  templateUrl: './app-confirm.component.html',
  styleUrls: ['./app-confirm.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
})
export class AppComfirmComponent {
  dialogName: string | undefined;
  deconnectionTimer: number;

  constructor(
    public dialogRef: MatDialogRef<AppComfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.dialogName) {
      this.dialogName = data.dialogName;
      this.startDeconnectionTimer();
    }
  }

  startDeconnectionTimer() {
    this.deconnectionTimer = 30;
    setInterval(() => {
      this.deconnectionTimer--;
      if (this.deconnectionTimer === 0) {
        this.dialogRef.close(false);
      }
    }, 1000);
  }
}
